
// src/api/http.ts
import api from '../services/api';

// Re-exporting the configured axios instance to be used in the new TypeScript services.
export default api;
